/**
 * API Base URL Configuration
 * 
 * All API calls use relative paths (/api/...) so frontend and backend
 * always resolve under the same origin. This is REQUIRED for:
 * - Shopify embedded iframe (same-origin policy)
 * - Cookie-based auth
 * - Avoiding CORS issues
 */

/**
 * Always returns '' — all API calls use relative /api/ paths.
 * The hosting infrastructure routes /api to the backend.
 */
export const getApiBase = () => '';

export const API_BASE = '';

export const isSameOrigin = () => true;

export default API_BASE;
